import { createElement } from 'react';
import 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import 'reakit/Input';
import { Icon as Icon$1 } from './styled.js';

var Icon = (function () {
  return createElement(Icon$1, {
    viewBox: "0 0 20 20",
    focusable: "false",
    "aria-hidden": "true"
  }, createElement("path", {
    d: "M13 8l-3-3-3 3h6zm-.1 4L10 14.9 7.1 12h5.8z",
    fillRule: "evenodd"
  }));
});

export default Icon;
